const aiAgentSelect =
  'id,name,isActive,description,iconUrl,provider,modelId,email,publisher,longDescription,instructions';
const rpaAgentSelect = 'id,name,isActive,deviceName,ip,agentPlatform,status';

export default {
  paged: {
    select: `${aiAgentSelect}`,
    expand: {
      model: { select: 'id,name' },
    },
  },

  detail: {
    select: `${aiAgentSelect},isPublic,allowedRoles,configurations,created,updated,creator,modifier`,
    expand: {
      model: { select: 'id,name' },
      connections: { select: 'id,name' },
      collaborators: { select: 'id', expand: { collaborator: { select: 'id,fullName' } } },
    },
  },

  edit: {
    select: `${aiAgentSelect},isPublic,allowedRoles,configurations`,
    expand: {
      model: { select: 'id,name' },
      connections: { select: 'id,name' },
      collaborators: { select: 'id', expand: { collaborator: { select: 'id,fullName' } } },
    },
  },

  rpaAgent: {
    paged: {
      select: `${rpaAgentSelect}`,
    },

    detail: {
      select: `${rpaAgentSelect},created,updated`,
      expand: {
        userCreator: { select: 'fullName' },
        userModifier: { select: 'fullName' },
      },
    },

    edit: {
      select: `${rpaAgentSelect}`,
    },
  },
};
